export function isFetchApiResponse(response: any): response is Response {
    return (response &&
        typeof response === "object" &&
        "status" in response &&
        "statusText" in response &&
        typeof response.status === "number");
}
